import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Title from './../../../common/TitlePage';


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        position: 'relative',
        padding: '82px 0px',
    },
    grid: {
        width: '51%',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        minWidth: '330px',

        [theme.breakpoints.down('sm')]: {
            width: '80%',
            fontSize: theme.fontSize.small,
            minWidth:'92%'
        },
    },
    Shape: {
        position: 'absolute',
        left: 0,
        bottom: 0,
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        },
        '& > .Rectangle1': {
            width: 150,
            height: 75,
            backgroundColor: '#F4F4F4',
        },
        '& > .Rectangle2': {
            width: 100,
            height: 75,
            marginTop: 20,
            backgroundColor: '#F4F4F4',
        },
    },
    title: {
        fontSize: theme.fontSize.xLarge,
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.fontSize.medium
        },
    },
    desc: {
        margin: '44px 0px 0px 0px',
        fontSize: theme.fontSize.regular,
        lineHeight: "35px",
        [theme.breakpoints.down('sm')]: {
            fontSize: theme.fontSize.small
        },
    }
}))


export default function Index() {

    const classes = useStyles();

    const state = {
        title: 'انواع روش‌های سرمایه گذاری در بورس ',
        desc: 'سرمایه گذاری در بازار بورس از 2 روش مستقیم و غیرمستقیم امکان پذیر است. سرمایه گذاری غیرمستقیم نیز خود از 2 طریق صندوق‌های سرمایه گذاری و شرکت‌های سبدگردانی انجام می‌شود. در سرمایه گذاری مستقیم خود شخص مستقیما اقدام به خرید و فروش می‌کند و مستلزم داشتن تخصص مالی، تجربه معامله گری، روحیه ریسک پذیری و صرف زمان کافی است. اما سرمایه گذاری غیرمستقیم مناسب کسانی است که تجربه فعالیت حرفه‌ای در بازار سهام را نداشته‌اند و از طرف دیگر، دانش تحلیلی و زمان کافی برای رصد بازار در طول جلسه معاملاتی را نیز ندارند.',
    }

    return (
        <div className={classes['root']}>
            {/* <div className={classes['Shape']}>
                <div className={'Rectangle1'}></div>
                <div className={'Rectangle2'}></div>
            </div> */}
            <div className={classes['grid']}>
                <Title position={'bottomCenter'} padding={'20px'}>
                    <span className={classes['title']} >{state.title}</span>
                </Title>
                <p className={classes['desc']}>{state.desc}</p>
            </div>
        </div>
    )
}
